import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';

export interface UploadOptions {
  parse: boolean;
  ingest: boolean;
}

@Component({
  selector: 'app-upload-options-dialog',
  standalone: true,
  imports: [FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 w-full max-w-sm mx-4 p-6">
        <h3 class="text-base font-semibold text-gray-900 dark:text-white mb-1">Upload options</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-5 truncate">{{ filename }}</p>

        <label class="flex items-start gap-3 cursor-pointer">
          <input type="checkbox" [(ngModel)]="options.parse" class="mt-1.5 accent-blue-600 cursor-pointer" />
          <div>
            <span class="text-sm font-medium text-gray-900 dark:text-white">Parse after upload</span>
            <p class="text-xs text-gray-500 dark:text-gray-400">Extract text using AI — review confidence before ingesting</p>
          </div>
        </label>

        <div class="flex justify-end gap-2 mt-6">
          <button
            (click)="cancel.emit()"
            class="px-4 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
            Cancel
          </button>
          <button
            (click)="confirmed.emit(options)"
            class="px-4 py-2 text-sm rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors">
            Upload
          </button>
        </div>
      </div>
    </div>
  `
})
export class UploadOptionsDialogComponent {
  @Input() filename = '';
  @Input() isVersionReplace = false;
  @Output() confirmed = new EventEmitter<UploadOptions>();
  @Output() cancel = new EventEmitter<void>();

  options: UploadOptions = { parse: true, ingest: false };
}
